export default __webpack_public_path__ + "static/button-functional-icon-02feb4c80b3845a54cac89f1477a8a44.png";